import React from 'react';
import { CheckCircle } from 'react-feather';
import './ReadyForReleaseBadge.css';

const ReadyForReleaseBadge = ({ className = '' }) => {
  return (
    <span className={`ready-for-release-badge ${className}`}>
      <CheckCircle size={14} />
      <span>Ready For Release</span>
    </span>
  );
};

export default ReadyForReleaseBadge;

